<template>
  <div id="app">
    <app-navbar></app-navbar>
    <router-view></router-view>
  </div>
</template>

<script>
import Navbar from './components/nav/Navbar.vue';

export default {
  name: 'App',
  components: {
    appNavbar: Navbar
  }
}
</script>
